import { getLocalizedStrings } from '../misc';

const {
  contentfulValues: {
    devicePolycomVVX150,
    devicePolycomVVX250,
    devicePolycomVVX350,
    deviceYealinkT42S,
    deviceYealinkT43U,
    deviceYealinkT48U,
    deviceYealinkT33G,
    deviceYealinkT33GOld,
    deviceYealinkT43UOld,
    deviceYealinkT48UOld
  }
} = getLocalizedStrings();

export const promoDeviceRate = 0.99;

export const hwcPromoDeviceRates = {
  [devicePolycomVVX150]: 0.01,
  [devicePolycomVVX250]: 40,
  [devicePolycomVVX350]: 75,
  [deviceYealinkT42S]: 25,
  [deviceYealinkT43U]: 45,
  [deviceYealinkT43UOld]: 45,
  [deviceYealinkT48U]: 110,
  [deviceYealinkT48UOld]: 110,
  [deviceYealinkT33G]: 0.01,
  [deviceYealinkT33GOld]: 0.01
};

export const rsiLicencesRate = {
  100: 220,
  250: 285,
  500: 355,
  1000: 495,
  2000: 785,
  3000: 1065
};

export const genesisLicencesRate = {
  35: 53,
  50: 70,
  75: 100,
  100: 120,
  150: 160,
  225: 190,
  300: 210,
  500: 260,
  1000: 280,
  1500: 315,
  3000: 345,
  5000: 465
};
